import { useEffect, useState } from "react";

/**
 * Returns false during SSR and on the very first client render, then true.
 * Use it to keep the first client render identical to the server output and
 * avoid React hydration mismatches (error #418) on auth-dependent screens.
 */
export function useHydrated() {
  const [hydrated, setHydrated] = useState(false);
  useEffect(() => setHydrated(true), []);
  return hydrated;
}
